import { apiGet, apiPost } from '../../../adapters/api-client/api';
import { RecordingStatus } from './session-evidence';

/** Opaque Chime Meeting / Attendee objects the Chime JS SDK needs to join. */
export type ChimeMeeting = Record<string, unknown>;
export type ChimeAttendee = Record<string, unknown>;

export interface StartSessionResult {
  started: boolean;
  reason?: string;
  roomId?: string;
  recordingUri?: string;
  meeting?: ChimeMeeting;
  attendee?: ChimeAttendee;
  milestone?: { recordingStatus?: RecordingStatus };
}

export interface SessionJoinInfo {
  meeting?: ChimeMeeting;
  attendee?: ChimeAttendee;
  /** The server's recording state for this class (DEC-S3-S08-08). */
  recordingStatus?: RecordingStatus;
}

/** Teacher: start a session against a confirmed booking (provisions room + recording). */
export function startSession(bookingId: string): Promise<StartSessionResult> {
  return apiPost(`/api/v1/sessions/${bookingId}/start`, {});
}

/** Teacher or parent: fresh Chime join info for an in-progress session. */
export function getSessionJoinInfo(bookingId: string): Promise<SessionJoinInfo> {
  return apiGet(`/api/v1/sessions/${bookingId}/join`);
}

/** Teacher: end the session — stops recording and triggers concatenation. */
export function endSession(bookingId: string): Promise<unknown> {
  return apiPost(`/api/v1/sessions/${bookingId}/end`, {});
}
